import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'jjames-gauge-chart',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './gauge-chart.component.html'
})
export class JJamesGaugeChartComponent {
    /** Current value (e.g. current occupancy) */
    readonly value = input<number>(0);

    /** Max capacity */
    readonly max = input<number>(10);

    /** Optional label */
    readonly label = input<string>('Occupancy');

    /** Units label */
    readonly unit = input<string>('cars');

    readonly percentage = computed(() => {
        const m = this.max();
        if (m <= 0) return 0;
        return Math.min(100, Math.max(0, (this.value() / m) * 100));
    });

    /** Status label and color classification */
    readonly statusCategory = computed<'available' | 'near_capacity' | 'full' | 'overflow'>(() => {
        const v = this.value();
        const m = this.max();
        if (v > m) return 'overflow';
        if (v === m) return 'full';
        if (v / m >= 0.75) return 'near_capacity';
        return 'available';
    });

    readonly strokeDashoffset = computed(() => {
        // Circumference for r=40 is ~251.3
        const circ = 251.3;
        const pct = this.percentage();
        return circ - (pct / 100) * circ;
    });
}
